'use strict';

export default class OPLGetCard {
    constructor() {
        this.formWrapper = null;
        this.form = null;
        this.progressBar = null;
        this.steps = null;
        this.locationOakvilleRadio = null;
        this.locationOutsideRadio = null;
        this.postalCodeResidentInput = null;
        this.postalCodeNonResidentInput = null;
        this.workSchoolInput = null;
        this.emailInput = null;
        this.confirmEmailInput = null;
        this.dobDayInput = null;
        this.dobMonthInput = null;
        this.dobYearInput = null;
    }

    init() {
        this.formWrapper = document.querySelector('#getacard-form-wrapper');
        this.form = document.querySelector('#getacard-form');
        this.progressBar = document.querySelector('.opl-getacard-progress');
        this.steps = document.querySelectorAll('.opl-getacard-form-step');
        this.locationOakvilleRadio = document.querySelector('#register-location-oakville');
        this.locationOutsideRadio = document.querySelector('#register-location-outside-oakville');
        this.postalCodeResidentInput = document.querySelector('#FormModel_PostalCodeResident');
        this.postalCodeNonResidentInput = document.querySelector('#FormModel_PostalCodeNonResident');
        this.workSchoolInput = document.querySelector('#FormModel_WorkSchoolName');
        this.emailInput = document.querySelector('#FormModel_Email');
        this.confirmEmailInput = document.querySelector('#FormModel_EmailConfirm');
        this.dobDayInput = document.querySelector('#FormModel_DateOfBirthDay');
        this.dobMonthInput = document.querySelector('#FormModel_DateOfBirthMonth');
        this.dobYearInput = document.querySelector('#FormModel_DateOfBirthYear');

        if (this.form) {
            this.restoreFormState();
            this.makeOneOfStepTwoNonRequired();
            this.initStepButtons();
            this.initPhoneNumberMask();
            this.initInputValidityClear();
        }
    }

    initInputValidityClear() {
        [this.postalCodeResidentInput, this.postalCodeNonResidentInput, this.confirmEmailInput, this.dobYearInput].forEach(input => {
            if (input) {
                input.addEventListener('input', () => {
                    input.setCustomValidity('');
                });
            }
        });
    }

    initStepButtons() {
        const self = this;

        const stepButtons = self.form.querySelectorAll('button[data-step]');
        stepButtons.forEach(btn => {
            btn.addEventListener('click', async () => {
                const nextStep = btn.dataset.step;
                const currentStep = self.form.querySelector('.opl-getacard-form-step.active');
                const isBackButton = btn.dataset.direction === 'back';

                if (!isBackButton) {
                    btn.classList.add('opl-loader-button');
                    const valid = await self.validateStep(currentStep);
                    btn.classList.remove('opl-loader-button');
                    if (!valid) return;
                }

                if (nextStep === "final") {
                    self.submitForm();
                } else {
                    self.showStep(self.resolveStep(nextStep));
                }
            });
        });
    }

    resolveStep(stepId) {
        if (stepId === 'step-two') {
            this.makeOneOfStepTwoNonRequired();
            return this.locationOakvilleRadio.checked ? 'step-two-a' : 'step-two-b';
        }
        return stepId;
    }

    showStep(stepId) {
        this.steps.forEach(step => step.classList.remove('active'));
        document.getElementById(stepId).classList.add('active');

        // Progress bar visual update
        this.progressBar.querySelectorAll('span').forEach(span => span.classList.remove('active'));
        const progressStep = this.progressBar.querySelector(stepId === 'step-two-a' || stepId === 'step-two-b' ? `.step-two` : `.${stepId}`);
        if (progressStep) progressStep.classList.add('active');

        // Progress bar aria update
        let ariaValueNow;
        switch (stepId) {
            case 'step-preset':
                ariaValueNow = 25;
                break;
            case 'step-two':
            case 'step-two-a':
            case 'step-two-b':
                ariaValueNow = 40;
                break;
            case 'step-three':
                ariaValueNow = 60;
                break;
            case 'step-four':
                ariaValueNow = 80;
                break;
            case 'step-five':
                ariaValueNow = 100;
                break;
            default:
                ariaValueNow = 25;
        }
        this.progressBar.setAttribute('aria-valuenow', ariaValueNow);

        window.scrollTo({ top: this.progressBar.offsetTop - 50, behavior: 'smooth' });
    }

    async validateStep(stepElement) {
        const inputs = stepElement.querySelectorAll('input, select, textarea');

        // Clear custom validity from previous steps before checking validity again
        inputs.forEach(input => input.setCustomValidity(''));

        let isValid = Array.from(inputs).every(input => {
            document.documentElement.style.scrollBehavior = 'auto'; // this is here because of this bug: https://issues.chromium.org/issues/40196176
            let inputValid = input.reportValidity();
            document.documentElement.style.scrollBehavior = '';
            return inputValid;
        });

        if (isValid) {
            // Custom: Email match
            if (stepElement.id === 'step-three') {
                if (this.emailInput && this.confirmEmailInput && this.emailInput.value !== this.confirmEmailInput.value) {
                    this.confirmEmailInput.setCustomValidity('Emails must match');
                    document.documentElement.style.scrollBehavior = 'auto';
                    this.confirmEmailInput.reportValidity();
                    document.documentElement.style.scrollBehavior = '';
                    isValid = false;
                } else {
                    this.confirmEmailInput.setCustomValidity('');
                }

                // Custom: Birthdate validation
                const year = parseInt(this.dobYearInput?.value);
                const month = parseInt(this.dobMonthInput?.value);
                const day = parseInt(this.dobDayInput?.value);
                if (!this.validateBirthdate(year, month, day)) {
                    this.dobYearInput.setCustomValidity(window.OPLGetCardStrings.BirthdateInvalid);
                    document.documentElement.style.scrollBehavior = 'auto';
                    this.dobYearInput.reportValidity();
                    document.documentElement.style.scrollBehavior = '';
                    isValid = false;
                } else {
                    this.dobYearInput.setCustomValidity('');
                }
            }

            // Custom: Postal code remote validation
            if (stepElement.id === 'step-two-a' || stepElement.id === 'step-two-b') {
                const postalInput = stepElement.id === 'step-two-a' ? this.postalCodeResidentInput : this.postalCodeNonResidentInput;
                if (postalInput) {
                    const postalValid = await this.validatePostalCode(postalInput);
                    if (!postalValid) {
                        postalInput.setCustomValidity(stepElement.id === 'step-two-a' ? window.OPLGetCardStrings.PostalCodeInvalidResident : window.OPLGetCardStringsPostalCodeInvalidNonResident);
                        document.documentElement.style.scrollBehavior = 'auto';
                        postalInput.reportValidity();
                        document.documentElement.style.scrollBehavior = '';
                        isValid = false;
                    } else {
                        postalInput.setCustomValidity('');
                    }
                }
            }
        }

        // Save state to session
        this.saveFormState(stepElement.id);

        return isValid;
    }

    async validatePostalCode(input) {
        input.disabled = true;

        try {
            const res = await fetch(`/api/get-card/check-postal?code=${encodeURIComponent(input.value)}`);
            const isValid = await res.json();
            return isValid;
        } catch (err) {
            console.error('Postal code validation failed', err);
            return false;
        } finally {
            input.disabled = false;
        }
    }

    validateBirthdate(year, month, day) {
        if (!year || !month || !day) return false;
        const dob = new Date(year, month - 1, day);
        const today = new Date();
        const age = today.getFullYear() - dob.getFullYear();

        return !(dob > today || age < 13 || dob.getMonth() !== month - 1 || dob.getDate() !== day);
    }

    saveFormState(stepId) {
        const data = {};
        const formData = new FormData(this.form);
        formData.forEach((value, key) => {
            data[key] = value;
        });
        sessionStorage.setItem('OPLGetACardFormData', JSON.stringify(data));
        sessionStorage.setItem('OPLGetACardFormStep', stepId);
    }

    restoreFormState() {
        const savedData = sessionStorage.getItem('OPLGetACardFormData');
        const savedStep = sessionStorage.getItem('OPLGetACardFormStep');
        if (!savedData || !savedStep) return;

        const values = JSON.parse(savedData);
        Object.keys(values).forEach(key => {
            const input = this.form.elements[key];
            if (!input) return;
            if (input.type === 'checkbox' || input.type === 'radio') {
                input.checked = values[key] === 'true';
            } else {
                input.value = values[key];
            }
        });

        this.showStep(savedStep);
    }

    submitForm() {
        const self = this;

        // Check recaptcha
        if (window.grecaptcha && window.grecaptcha.getResponse() === '') {
            alert('Please check the recaptcha.');
            return;
        }

        const loader = self.form.querySelector('.opl-loader');
        if (loader) loader.style.display = 'block';

        // AJAX submit
        const data = new FormData(self.form);
        fetch('/api/get-card/register', {
            method: 'POST',
            body: data,
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
            .then(res => res.text())
            .then(html => {
                // Replace wrapper contents with partial
                self.formWrapper.innerHTML = html;
                self.init(); // re-init in case the form returns
            })
            .catch(() => alert('Submission failed, try again.'))
            .finally(() => {
                if (loader) loader.style.display = 'none';
            });
    }

    initPhoneNumberMask() {
        const self = this;

        const phoneNumberInput = self.form.querySelector('#FormModel_TelephoneNumber');
        phoneNumberInput.addEventListener('input', function () {
            let value = phoneNumberInput.value.replace(/\D/g, ''); // Remove non-digit
            if (value.length > 10) value = value.slice(0, 10);

            let formatted = '';
            if (value.length > 0) {
                formatted += value.substring(0, 3);
            }
            if (value.length > 3) {
                formatted += '-' + value.substring(3, 6);
            }
            if (value.length > 6) {
                formatted += '-' + value.substring(6, 10);
            }

            phoneNumberInput.value = formatted;
        });

        phoneNumberInput.addEventListener('blur', function () {
            // On blur, force format if possible
            let value = phoneNumberInput.value.replace(/\D/g, '');
            if (value.length === 10) {
                phoneNumberInput.value = value.substring(0, 3) + '-' + value.substring(3, 6) + '-' + value.substring(6, 10);
            }
        });
    }

    makeOneOfStepTwoNonRequired() {
        const isResident = this.locationOakvilleRadio.checked;

        if (isResident) {
            this.workSchoolInput.removeAttribute('required');
            this.postalCodeNonResidentInput.removeAttribute('required');
            this.postalCodeResidentInput.setAttribute('required', 'required');
        } else {
            this.workSchoolInput.setAttribute('required', 'required');
            this.postalCodeNonResidentInput.setAttribute('required', 'required');
            this.postalCodeResidentInput.removeAttribute('required');
        }
    }
}
